import App from '@/AppOnBoarding'
import router from '@/router/onboarding'
import store from '@/store'
import init from '@/init'

const APP_ID = 'onboarding'

init(APP_ID, App, router, store)
